module.exports = __webpack_public_path__ + "static/google-badge-514767816301b659187db3f678cedcfe.svg";